import {CsatCreateSurveyEndpointResponseSuccess} from '@stripe-internal/conversations-shared-dependencies';
import {RatingValue} from '../../../components/Forms/CSAT/types';

export type CreateCSATSurveyRequest = {
  conversationId: string;
};

export async function createCSATSurvey(
  supportFetch: typeof fetch,
  {conversationId}: CreateCSATSurveyRequest,
): Promise<CsatCreateSurveyEndpointResponseSuccess> {
  const response = await supportFetch('/api/csat', {
    method: 'POST',
    body: JSON.stringify({conversationId}),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('failed to create csat survey');
  }

  return response.json();
}

export type SubmitCSATRatingRequest = {
  csatSurveyToken: string;
  rating: RatingValue;
  comment: string;
};

export async function submitCSATRating(
  supportFetch: typeof fetch,
  {csatSurveyToken, rating, comment}: SubmitCSATRatingRequest,
): Promise<void> {
  const response = await supportFetch(`/api/csat/${csatSurveyToken}/rating`, {
    method: 'POST',
    body: JSON.stringify({rating, comment}),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('failed to submit rating');
  }
}
